import React, { useEffect, useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PK, API_ROOT } from "../constants";
import axios from "axios";
import { useSelector } from "react-redux";
import { totalBasket } from "../helpers";
import { trackEvent, EC_SHOP, E_GONE_TO_CHECKOUT } from "../helpers/tracking";
import BasketSummary from "./Vendor/Basket/BasketSummary";
import { Spinner } from "../assets";

export default function Checkout({ blocked }) {

	const { vendor, token, basket } = useSelector(state => ({
		token: state.session.token,
		vendor: state.vendor,
		basket: state.basket
	}));

	const [grandTotal] = totalBasket(basket, vendor);

	const [stripe, setStripe] = useState(null);
	const [working, setWorking] = useState(false);
	const [error, setError] = useState(null);

	// Initialise Stripe on mount.
	useEffect(() => {
		(async function () {
			const stripeInstance = await loadStripe(STRIPE_PK);
			setStripe(stripeInstance);
		})();
	}, []);

	if (!stripe) return <Spinner />;

	return <div className="checkout">
		<BasketSummary />
		<button
			className={[
				"checkout-button",
				Boolean(working || blocked) && "disabled"
			].filter(c => c).join(" ")}
			disabled={basket.loading || working || blocked}
			onClick={e => {
				if (!blocked) {
					setError(null);
					setWorking(true);
					trackEvent(EC_SHOP, E_GONE_TO_CHECKOUT, `${vendor.id}_${vendor.name}`);
					getStripeSession(vendor.id, token).then(session => {
						stripe.redirectToCheckout({
							sessionId: session.id
						});
					}).catch(err => {
						setError(err.message || err);
						setWorking(false);
					});
				}
			}}
		>{(basket.loading || working || blocked) ? <Spinner /> : <span>
			Place Order<span className="brand-c">+</span> £{(grandTotal / 100).toFixed(2)}
		</span>}</button>
		{error && <div className="error">{error}</div>}
	</div>
}

function getStripeSession(vendorId, token) {
	return new Promise((resolve, reject) => {
		axios.get(`${API_ROOT}/basket/${vendorId}/stripe-session`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
			.then(res => res.data)
			.then(resolve)
			.catch(err => reject(err.message));
	});
}